var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,5 C14.7793939,5 17.6,7.82060608 17.6,11.3 C17.6,12.7875972 17.0844083,14.1547714 16.2221773,15.2325704 L18.7949747,17.8050253 C19.0683418,18.0783923 19.0683418,18.5216077 18.7949747,18.7949747 C18.542636,19.0473135 18.1455742,19.0667242 17.8709704,18.8532068 L17.8050253,18.7949747 L15.2325704,16.2221773 C14.1547714,17.0844083 12.7875972,17.6 11.3,17.6 C7.82060608,17.6 5,14.7793939 5,11.3 C5,7.82060608 7.82060608,5 11.3,5 Z M11.3,6.4 C8.59380473,6.4 6.4,8.59380473 6.4,11.3 C6.4,14.0061953 8.59380473,16.2 11.3,16.2 C12.6293142,16.2 13.8349944,15.6706596 14.7177529,14.8112665 C14.7291624,14.7923862 14.7441318,14.7759187 14.7600253,14.7600253 L14.809282,14.7197902 C15.6698446,13.8368499 16.2,12.6303372 16.2,11.3 C16.2,8.59380473 14.0061953,6.4 11.3,6.4 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.844b2e8a9d965b2660d2ea010ab52528.svg";
export { ForwardRef as ReactComponent };